import { Component, inject, OnInit, ChangeDetectorRef } from "@angular/core";
import { LAYOUT_TYPE, OptionsFetchConfig } from "../../model/common.model";
import { FieldNames, FieldTypesForOptions } from "../../model/form-fields.model";
import { TabConfig, FormFieldConfig, FieldOption } from "../../model/form.model";
import { CommonUtils } from "../../utils/common.utils";
import { PageContainerComponent } from "../../layout/page-container/page-container.component";
import {  ElevateBillingDynamicOptionSchema, ElevateBillingTabIds, ElevateBillingTabSchema, ElevateBillingTitle } from "../../model/elevate-billing.model";
import { API_STATUS, ApiEnvNames, ERROR_RESPONSE } from "../../model/api.model";
import { CommonService } from "../../services/common.service";

@Component({
  selector: 'app-elevate-billing',
  standalone: true,
  imports: [PageContainerComponent],
  templateUrl: './elevate-billing.component.html',
  styleUrl:'./elevate-billing.component.scss'
})
export class ElevateBillingComponent implements OnInit {
  title: string = ElevateBillingTitle;
  readonly LayoutType: typeof LAYOUT_TYPE = LAYOUT_TYPE;
  tabConfig: Array<TabConfig> = ElevateBillingTabSchema;
  private readonly commonUtils = inject(CommonUtils)
  private readonly service = inject(CommonService);
  private readonly changeRef = inject(ChangeDetectorRef);
  ngOnInit(){
    this.initializeLayout();
  }
  initializeLayout(){
    this.fetchAndUpdateOptions()
  }
  setDefaultValue(field:FormFieldConfig){
    if(field['fieldName'] === FieldNames['Event']){ 
      if(field?.options){
        const lastYear = new Date().getFullYear() - 1;
        const value =  field.options.find(option=> option['fieldValue'].slice(-4) === lastYear.toString()) ;
        if(value){
          field['defaultValue'] = value['fieldValue'] ?? ''
        }else{
          field['defaultValue'] = field['options'][0]['fieldValue']
        }
        field['selectedValue'] = field['defaultValue'];
      }
      
    }else if(field['fieldName'] === FieldNames['JobRole']){
      field['defaultValue'] = field?.options?.[0]['fieldValue'] ?? ''
      field['selectedValue'] = field['defaultValue'];
    }
  }
  elevateBillingDynamicOptionFields: OptionsFetchConfig = ElevateBillingDynamicOptionSchema;
   fetchAndUpdateOptions = async() => {
    try{
      const response = await this.service.getDataFromDataSource(this.elevateBillingDynamicOptionFields.searchConfig, ApiEnvNames['ElevateBilling'])
      if (response['status'] === API_STATUS['Success']) {
        if (Array.isArray(response.result)) {
          this.fillValuesFromApi(response.result[0]);
        }
      } else {
         this.commonUtils.showMatSnackBar(ERROR_RESPONSE['errorFetch'])
      }      
    }catch(err){
      console.info('Layout Error:- ', err);
    }
  };
  fillValuesFromApi = (response: any) => {
    const result:Record<string,Array<FieldOption>> = {};
    const fieldNames = new Set(this.elevateBillingDynamicOptionFields.fields.map(p => p.name));
    const dropdownData = response['dropdowns']
    if(dropdownData){
      Object.keys(dropdownData).forEach(fieldName=>{
        if(!result[fieldName]){
          result[fieldName] = []
        }
        if(dropdownData[fieldName] && dropdownData[fieldName].length>0){
          result[fieldName] = dropdownData[fieldName].map((item:string)=> ({'fieldLabel': item, 'fieldValue': item}))
        }else{
          result[fieldName] = [];
        }
        
      })
    }
    const updateOptions = (filterSchema:FormFieldConfig[],_options:any)=>{
      if(filterSchema){
        filterSchema.forEach(field=>{
          if(FieldTypesForOptions.includes(field['fieldType']) && fieldNames.has(field['fieldName'])){
            field['options'] = result[field['fieldName']]
            this.setDefaultValue(field)
            field['isLoading'] = false
          }
        })
      }
    }
    this.tabConfig.forEach(tab=>{
      if(tab['tabId'] === ElevateBillingTabIds['Dashboard']){
        const gridSchema = tab.inputs.gridSchema;
        if(gridSchema){
          gridSchema.forEach(gridElm=>{
            if(gridElm.inputs.filterSchema){
              updateOptions(gridElm.inputs.filterSchema.FieldsArray,result)
            }
          })
        }
      }else if(tab['inputs']['filterSchema']){
          updateOptions(tab.inputs.filterSchema.FieldsArray,result)
        }
    })
    this.changeRef.detectChanges();
  }
}
